__webpack_require__.p = "https://iitg.ac.in/sa/ai/";